var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loader'),_c('div',{staticClass:"wrapper"},[_c('SidebarStyle'),_c('HeaderStyle1'),_c('div',{staticClass:"content-page"},[_c('transition',{attrs:{"name":"router-anim"}},[_c('router-view')],1)],1)],1),_c('FooterStyle')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }